<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="10" viewBox="0 -960 960 960" width="10"><path d="M457.308-180.001v-513.692L212.001-448.385l-32-31.615L480-779.999 779.999-480l-32 31.615-245.307-245.308v513.692h-45.384Z"/></svg>
</template>
